define("authui/login2/controllers/baseLoginController",[
        "base/utils/cookie",
        "base/utils/preVerifycodeUtil",
        "base/utils/iamHttpService",
        "base/utils/utility"
    ], function(cookieOp, perVerifycodeUtil, iamHttpService,utils){
    "use strict";
    var i18n, iamUtils, me, $state;

    function LoginController($scope, $timeout, securityPolicy, _i18n, _iamUtils, _$state) {
        $state = _$state;
        i18n = _i18n;
        iamUtils = _iamUtils;
        me = this;

        $scope.goLoginType="HWS";

        document.title = i18n("titles.login");

        $scope.i18n = i18n;
        $scope.securityPolicy = securityPolicy;

        // 是否为国际IP
        $scope.ipIsInternational = iamUtils.ipIsInternational();

        function send2CloudBISafe(){
            try{
                send2CloudBI.apply(null,arguments);

            }catch(e){
                console.dir(e)
            }
        }

        $scope.model = {
            // 密码的显示与隐藏
            pwdVisible: false,
            pwdVisibleFunc: function() {
                $scope.model.pwdVisible = !$scope.model.pwdVisible;
                var type = $scope.model.pwdVisible ? "text" : "password";
                $("#pwdId>input").attr("type", type);
            },

            width: iamUtils.layout.inputFiledWidth,
            widthHalf: "49%",
            height: iamUtils.layout.inputFieldHeight,
            optionWidth:"110px",
            inputFieldHeight: iamUtils.layout.inputFieldHeight,
            scrollHeight: iamUtils.layout.scrollHeight,
            homepageUrl: iamUtils.CONFIG.homepageUrl,
            pageImgSrc: me.getPageImgSrc(),
            submitBtnText: i18n('loginSubmit'),
            maxLength: 4,
            userNamePH: me.getLastLoginUserType() === "company"? i18n("userNamePlaceHolder") : i18n("accountNamePlaceHolder"),
            userNamePH_HK: me.getLastLoginUserType() === "company"? i18n("HongKongUserNamePlaceHolder") : i18n("HongKongAccountNamePlaceHolder"),
            currentUserType: i18n("enterpriseUser"),
            otherUserType: i18n("personageUser"),
            countryCode: "",
            codeJson:"",
            codeArray:[],
            defaultCode: "",
            goLogin: "",
            goLogin1: "",
            matchMethod: function(keyword, op) {
                keyword = keyword.trim();
                if((op.toLowerCase().indexOf(keyword.toLowerCase()) >= 0) || (keyword == "00" + op.substring(op.indexOf("+") + 1, op.indexOf(")")))){
                return true;
                }
            },  
            isCompany: me.getLastLoginUserType() === "company",
            accountNameId: "accountNameId",
            accountNamePH: i18n("accountPlaceHolder"),
            accountFocused: this.isCompany ? true : false,
            lastAccountName: iamUtils.needRecordUsername ? cookieOp.getCookie("account") : "",
            userNameId: "userNameId",
            // nameFocused: false,
            userNameCookie: iamUtils.needRecordUsername,
            lastUserName: iamUtils.needRecordUsername ? cookieOp.getCookie("name") : "",
            codeSelectId:"codeSelectId",
            mobileNumberLogin: i18n('mobileNumberLogin'),
            noMobileLogin: i18n("noMobileLogin"),
            mobileLogin: false,
            phoneIAMFocused: false,
            phoneMaxLength:225,
            tipPosition: "top",
            lastPhoneAccountName: iamUtils.needRecordUsername ? cookieOp.getCookie("mobile") : "",
            pwdId: "pwdId",
            pwdPH: i18n("passwdPlaceHolder"),
            pwdType: "password",
            pwdFocused: false,
            pwdChange: function() {
                var val = $("#"+$scope.model.pwdId+">input").length > 0 ? $("#"+$scope.model.pwdId+">input").val() : "";
                var pwdInputObj = $("#"+$scope.model.pwdId+">input");
                //firefox bug: type first character and change input type, cursor will jump forward,so move it end.
                if(val.length === 1){
                    if(pwdInputObj.length > 0){
                        var input = pwdInputObj[0];

                        if (input.createTextRange) { //IE
                            var range = input.createTextRange();
                            range.collapse(true);
                            range.move('character', 1);
                            range.select();
                        }
                        else if(input.setSelectionRange) //other browsers
                        {
                            input.setSelectionRange(1,1);
                            input.focus();
                        }
                    }
                }
                $scope.model.serverError = "";
                $scope.model.goLogin = "";
                $scope.model.goLogin1 = "";
                $("#checkError").hide();
                $timeout(function() {
                    $scope.$digest();
                });
            },
            pwdBlur: function () {
                send2CloudBISafe("input", "change" , "login_" + ($scope.model.isCompany ? 'company' : 'personal') +"_password", "***");
            },
            checkCodeId: "checkCodeId",
            checkCodePH: i18n("verifyCodePlaceHolder"),
            checkCodeTip: i18n("getVerifyCode"),
            initRandom: Math.random(),
            chkTxt: i18n("rememberName"),
            chkId: "chkId",
            // 记住登录名国内IP默认勾选 海外IP根据cookie
            rememberChecked: $scope.ipIsInternational ? (cookieOp.getCookie("rememberChecked") ? true : false) : true,
            checkCodeErrorMsg: "",
            isSubmitBtnDisabled: false,
            verifycode :  "/authui/verifycode?index=1&alt="+Math.random(),
            isNeedVerifyCode: false,
            isCookieEnable:navigator.cookieEnabled,
            cookieURL:getCookieURL(me.getLastLoginUserType() === "company"),
            areaCodeDisabled: false,
            countryCodeValue: "",
            checkErrorInfo: "",
            errorMsgObj : {
                "401": i18n("wrongNamePwd"),
                "402": i18n("wrongNamePwdoneChances"),
                "403": i18n("wrongNamePwdTwoChances"),
                "404": i18n("wrongNamePwdThreeChances"),
                "405": i18n("wrongNamePwdFourChances"),
                "406": i18n("invalidInput"),
                "407": i18n("invalidInputoneChances"),
                "408": i18n("invalidInputTwoChances"),
                "409": i18n("invalidInputThreeChances"),
                "410": i18n("invalidInputFourChances"),
                "411": i18n("wrongVerifyCode"),
                "412": i18n("loginReactivateFail"),
                "413": i18n("userAccountsLocked"),
                "414": i18n("domainuserAccountsLocked"),
                "415": i18n("userAccountsLocked"),
                "417": i18n("systemException"),
                "418": i18n("verifyCode.error"),
                "419": i18n("verifyCode.invalid"),
                "420": i18n("userAccountsStopped"),
                "423": i18n("serviceUrlInvalid"),
                "424": i18n("maxSessionLimit"),
                "427": i18n("multiUserInvalid"),
                "428": i18n("accountClosed"),
                "430": i18n("hasBindUniportal"),
                "432": i18n("pageTimeout"),
                "508121000": i18n("wrongIPBlacklist"),
                "508121001": i18n("wrongIPFrequencyLimiting"),
                "508121002": i18n("wrongEquipmentIDFrequencyLimiting"),
                "508121003": i18n("MachineOperation")

            }
        };

        $(document).keydown(function (event) {
            if(event.keyCode === 13){
                var id = me.getActiveElementId();
                if ($(document.activeElement).attr("id") === "loginBtn" || ($scope.model.isNeedVerifyCode && id === "checkCodeId")
                    || id === "personalAccountInputId" || id === "personalPasswordInputId"
                    || id === "mobilePasswordInputId"
                    || id === "IAMAccountInputId" || id === "IAMUsernameInputId" || id === "IAMPasswordInputId") {
                    $scope.loginClick();
                    $scope.$apply();
                }
            }
        });
        
        $scope.model.codeSelectWidth = "115px";
        $scope.model.codeInputWidth = "165px";
        $scope.model.registUrl = getRegistUrl();
        $scope.model.checkFlag = false;
        
        initCountryCode($scope, initUserType);
        $scope.model.countryCodeValidator = iamUtils.validator.countryCode($scope.model.codeArray);
    
        $scope.loginClick = function() {
            send2CloudBISafe("button", "click" , "login_" + ($scope.model.isCompany ? 'company' : 'personal'), '');
            me.onSubmitBtnClick($scope);
        }
        
        $scope.BiEvent = function(){
            try{
                var tempGa = $.extend([],arguments);
                tempGa[tempGa.length-1] = 1;

                ga.apply(null,tempGa);
                var temp = $.extend([],arguments);
                send2CloudBI.apply(null, temp.slice(2));
            }catch(e){
                console.dir(e)
            }
            return false;
        }

        $scope.model.getVerifyCode = function(){
            send2CloudBISafe("button", "click" , "login_" + ($scope.model.isCompany ? 'company' : 'personal')+"_getVerifyCode", '');
            var verifyCodeImg = $("#inputVerifyCodeImg")[0];
            if(verifyCodeImg)
            {
                verifyCodeImg.src = "/authui/verifycode?index=1&alt="+Math.random();
            }
            $scope.model.checkCode = "";
            $("#validresultImg").hide();
        };

        showErrorMsg($scope, $("#loginServerErrorMsg")[0].innerHTML);

        $("#ownerLogin").on("mousedown keydown", function (event) {
            if(event.button == 0 || event.keyCode == 13){
                $scope.model.isCompany = false;
                $scope.model.defaultValue = $scope.model.defaultCode;
                $scope.model.isIAMUserLogin = true;
                me.onUserTypeChange($scope, $timeout);
                $("#validresultImg").hide();
            }
        });
        $("#subUserLogin").on("mousedown keydown", function (event) {
            if(event.button == 0 || event.keyCode == 13){
                $scope.model.isCompany = true;
                $scope.model.defaultValue = $scope.model.defaultCode;
                $scope.model.isIAMUserLogin = false;
                me.onUserTypeChange($scope, $timeout);
                $scope.$digest();
                $("#validresultImg").hide();
            }
        });

        //支持tab+enter键切换
        $("#typeSwitchBtn").on("keydown",
            function(event){
                if(event.keyCode === 13){
                    $scope.mobileLoginModel.switchTypeClick({which: 1});
                    $scope.$apply();
                }
            }
        );

        $scope.model.preValidVerifyCode = function(event, value)
        {
            var img = $("#validresultImg");
            perVerifycodeUtil.preValidVerifyCode(img, value, "1", preValidCallback, iamHttpService, i18n);
        }

        $scope.model.preValidVerifyCodeBlur= function (event ,value){
            send2CloudBISafe("input", "change" , "login_" + ($scope.model.isCompany ? 'company' : 'personal') +"_VerifyCode", $scope.model.checkCode);
        }

        $scope.model.rememberCheckedChange = function (event, value){
            send2CloudBISafe("input", "change" , "login_" + ($scope.model.isCompany ? 'company' : 'personal') +"_rememberChecked", $scope.model.rememberChecked);
        }

        function preValidCallback()
        {
            $scope.model.checkCode = "";
            $scope.$apply();
            var verifyCodeImg = $("#inputVerifyCodeImg")[0];
            if(verifyCodeImg)
            {
                verifyCodeImg.src = "/authui/verifycode?index=1&alt="+Math.random();
            }
        }

        $scope.model.accountValidator = [iamUtils.validator.childValidator.limitLength(255)];
        $scope.model.userValidator = [iamUtils.validator.childValidator.limitLength(255)];
        $scope.model.pwdValidator = [iamUtils.validator.childValidator.limitLength(128)];
        $scope.model.checkCodeValidator = [iamUtils.validator.childValidator.limitLength(4)];

        //$scope.defaultLoginAdv();

        $scope.defaultLoginAdv = function(){
            document.getElementById("loginAdv").innerHTML = "<img id='loginAdImgDefault' style='display:none' src='"+ $scope.model.pageImgSrc + "'>";
            setTimeout(function() {
                if ($("#loginAdImgDefault"))
                {
                    $("#loginAdImgDefault").show();
                }
            }, 1000);

            document.getElementById("loginAdv").onclick=function(){
                send2CloudBISafe("input", "change" , "login_" + ($scope.model.isCompany ? 'company' : 'personal') +"_loginAdv", $scope.model.pageImgSrc);
            }
        }

        $scope.defaultLoginAdv();
    }

    LoginController.prototype.getActiveElementId = function() {
        return $(document.activeElement.parentNode).attr("id");
    }

    function getCookieURL(isCurCompany) {
        // return "/authui/login.html?locale=" + window.language + "&UserType=" + (isCurCompany ? "e" : "p") + getServiceFromUrl() + "#/closecookie";
        return "#/closecookie?locale=" + window.language + "&UserType=" + (isCurCompany ? "e" : "p") + getServiceFromUrl();
    }

    function getServiceFromUrl() {
        var service = iamUtils.getUrlParams()["service"];
        if (service) {
            return "&service=" + encodeURIComponent(service);
        }
        return "";
    }

    function getRegistUrl() {
        var callbackUrl = window.location.search;
        var registUrl = "/authui/auth.html?locale=" + window.language + getServiceFromUrl() + "#/register";

        //将BP注册入口集成到IAM登陆界面
        if (decodeURIComponent(callbackUrl).indexOf("//bp.huaweicloud.com") != -1) {
            registUrl = "https://bp.huaweicloud.com/customer/account/registera";
        }
        return registUrl;
    }
    

    function initCountryCode($scope, callback){
        var codeArray = [];
        iamHttpService.get({
            url:"/authui/getCountryCode",
            params:{}
        }).then(function (data) {
            data = typeof data === 'object' ? data : $.parseJSON(data);
            var codeList = data["codeArray"];
            var defaultCode = data["defaultCode"];
            if (codeList.length) {
                codeList = codeList.sort(iamUtils.SortArray('label'));
                $scope.model.codeJson = codeList;
                $scope.model.defaultValue = iamUtils.getCountryValue(codeList, defaultCode);
                $scope.model.defaultCode = iamUtils.getCountryValue(codeList, defaultCode);
                $scope.model.countryCodeValue = $scope.model.defaultValue;
                for(var item in codeList){
                    if (codeList[item].id === defaultCode) {
                        codeArray.push(codeList[item].label);    
                    }
                }
                $scope.model.codeValues = codeArray;
                callback($scope);
            }
        }, function(){
            callback($scope);
        })
        $scope.model.codeArray = codeArray;
    }
    LoginController.getServiceFromUrl = getServiceFromUrl;

    LoginController.prototype.getLastLoginUserType = function(){
        var loginType = cookieOp.getCookie("loginType");
        if (loginType === undefined) {
            return "";
        } else {
            return loginType;
        }
    };

    function recordLoginType($scope) {
        // 如果未勾选 记住登录名 则不记录上次的登录方式
        if ($scope.model.rememberChecked) {
            var value = $scope.model.isCompany ? "company" : "personal";
            if ($scope.model.mobileLogin) {
                value = "mobile";
            }
            cookieOp.addCookie("loginType", value, cookieOp.DEFAULT_EXPIRES_TIME);
        }
    }

    function recordUserType (isCompany) {
        var value = isCompany ? "company" : "personal";
        cookieOp.addCookie("accountType", value, cookieOp.DEFAULT_EXPIRES_TIME);
    }

    function recordLoginCookie($scope, countryCode, type) {
        if (type === "forLogin") {
            // 登录成功时 为登录页面记录cookie
            if (!$scope.model.userNameCookie) {
                return;
            }
            // 登录之后清除标记了找回密码方式的cookie
            cookieOp.delCookie("findPwdEnd");

            if ($scope.model.rememberChecked) {
                if ($scope.model.isCompany) {
                    // IAM用户登录方式
                    cookieOp.addCookie("IAMAccount", $scope.IAMAccountInput.value.trim(), cookieOp.DEFAULT_EXPIRES_TIME);
                    cookieOp.addCookie("IAMUsername", $scope.IAMUsernameInput.value.trim(), cookieOp.DEFAULT_EXPIRES_TIME);
                } else {
                    // 个人帐号登录方式
                    if(!$scope.model.mobileLogin){
                        // 帐号邮箱登录
                        cookieOp.addCookie("personalAccount", $scope.personalAccountInput.value.trim(), cookieOp.DEFAULT_EXPIRES_TIME);
                    }else{
                        // 手机登录
                        cookieOp.addCookie("countryCode", countryCode, cookieOp.DEFAULT_EXPIRES_TIME);
                        cookieOp.addCookie("mobile", $scope.mobileInput.value.trim(), cookieOp.DEFAULT_EXPIRES_TIME);
                    }
                }
                cookieOp.addCookie("rememberChecked", true, cookieOp.DEFAULT_EXPIRES_TIME);
                // cookieOp.addCookie("rememberIsPhoneAccountName", mobileLogin, cookieOp.DEFAULT_EXPIRES_TIME);
            } else {
                // 登录方式的cookie
                cookieOp.delCookie("loginType");
                // 记住登录名的cookie
                cookieOp.delCookie("rememberChecked");
                // 帐号登录方式时主帐号
                cookieOp.delCookie("personalAccount");
                // IAM登录方式 主帐号
                cookieOp.delCookie("IAMAccount");
                // IAM登录方式 子用户
                cookieOp.delCookie("IAMUsername");
                // IAM登录方式 子用户是手机时
                cookieOp.delCookie("countryCode");
                cookieOp.delCookie('mobile');
            }
        } else if (type === "forFindPwd") {

            // 登录方式的cookie
            cookieOp.delCookie("loginType");
            // 记住登录名的cookie
            cookieOp.delCookie("rememberChecked");
            // 帐号登录方式时主帐号
            cookieOp.delCookie("personalAccount");
            // IAM登录方式 主帐号
            cookieOp.delCookie("IAMAccount");
            // IAM登录方式 子用户
            cookieOp.delCookie("IAMUsername");
            // IAM登录方式 子用户是手机时
            cookieOp.delCookie("countryCode");
            cookieOp.delCookie('mobile');

            // 登录失败时 为找回密码页面记录cookie
            var loginType = $scope.model.mobileLogin ? "mobile" : $scope.model.isCompany ? "company" : "personal";
            if ($scope.model.mobileLogin) {
                cookieOp.addCookie("loginType", "mobile", cookieOp.DEFAULT_EXPIRES_TIME);
                cookieOp.addCookie("countryCode", countryCode, cookieOp.DEFAULT_EXPIRES_TIME);
                cookieOp.addCookie("mobile", $scope.mobileInput.value.trim(), cookieOp.DEFAULT_EXPIRES_TIME);
            } else if (!$scope.model.isCompany) {
                cookieOp.addCookie("loginType", "personal", cookieOp.DEFAULT_EXPIRES_TIME);
                cookieOp.addCookie("personalAccount", $scope.personalAccountInput.value.trim(), cookieOp.DEFAULT_EXPIRES_TIME);
            } else if ($scope.model.isCompany) {
                cookieOp.addCookie("loginType", "company", cookieOp.DEFAULT_EXPIRES_TIME);
                cookieOp.addCookie("IAMAccount", $scope.IAMAccountInput.value.trim(), cookieOp.DEFAULT_EXPIRES_TIME);
                cookieOp.addCookie("IAMUsername", $scope.IAMUsernameInput.value.trim(), cookieOp.DEFAULT_EXPIRES_TIME);
            }
        } else {
            // default
        }
    }

    function isValUnvalid(value){
        return (value === "" || value === undefined);
    }

    LoginController.prototype.showErrorTip = function (id, $scope) {
        var msgParentDom = $("#checkError");
        msgParentDom.show();
        var serverError = $("#serverError");
        serverError.hide();

        var id2ErrInfo = {
            "accountNameBlank": i18n('accountNameBlank'),
            "userNameBlank": i18n('userNameBlank'),
            "pwdBlank": i18n('pwdBlank'),
            "checkCodeBlank": $scope.model.checkCodeErrorMsg,
            "domainWrong": i18n('wrongNamePwd'),
            "smsCodeError": $scope.model.smsCodeError,
            "inValidCountryCode": i18n('inValidCountryCode'),
            "phoneBlank": i18n('phoneBlank')
        };

        $scope.model.checkErrorInfo = "";
        if (id2ErrInfo[id]) {
            $scope.model.checkErrorInfo = id2ErrInfo[id];
        }
    }

    LoginController.prototype.disabledLoginBtn = function($scope) {
        var loginBtn = $("#loginBtn");
        var btnText = loginBtn.children()[0];
        $(btnText).html(i18n("logining"));
        loginBtn.removeClass("loginBtn");
        loginBtn.addClass("loginBtnDisabled");
        $scope.model.isSubmitBtnDisabled = true;
    }

    LoginController.prototype.restoreBtn = function($scope) {
        var loginBtn = $("#loginBtn");
        var btnText = loginBtn.children()[0];
        loginBtn.removeClass("loginBtnDisabled");
        loginBtn.addClass("loginBtn");
        $(btnText).html(i18n("loginSubmit"));
        $scope.model.isSubmitBtnDisabled = false;
    }

    LoginController.prototype.onSubmitBtnClick =function($scope) {

        if (!window.tinyWidget.UnifyValid.FormValid($("#loginForm"))) {
            // 校验不通过 不可提交
            return;
        }
        var model = $scope.model;
        var securityPolicy = $scope.securityPolicy;

        if($scope.model.isSubmitBtnDisabled) {
            return;
        }
        me.disabledLoginBtn($scope);

        // 记录登录方式到cookie
        recordLoginType($scope);
        cookieOp.delCookie("enterprise_idp");

        // 记录 accountType，与更换手机号等页面兼容: https://wa.vision.huawei.com/#/product/domains/6205/issues/version/list/bug/BUG2019111401458
        recordUserType(model.isCompany);

        var accountName = model.accountName === undefined ? "" : model.accountName.trim();
        model.userName = iamUtils.getTrimValue(model.userNameId);
        var userName = model.userName === undefined ? "" : model.userName.trim();
        var mobileValue = $scope.mobileInput.value === undefined ? "" : $scope.mobileInput.value.trim();
        
        var countryCode = iamUtils.getCodeValue(model.codeJson, model.defaultValue);
        if(!model.isCompany && model.mobileLogin) {
            countryCode = iamUtils.getCodeValue(model.codeJson, $("#codeSelectId").widget().getValue());
            if(countryCode === undefined)
            {
                me.showErrorTip("inValidCountryCode", $scope);
                me.restoreBtn($scope);
                return;
            }
        }
        if(countryCode === undefined){
           countryCode = "";
        }


        var checkCode = model.isNeedVerifyCode ? $("#"+model.checkCodeId).widget().getValue() : "";

        var isCmpyLogin = model.isCompany;

        // 定义传参时用到的密码字段
        var passwd = "";

        // 区分主帐号登录 与 IAM子用户登录
        if (!model.isCompany) {
            // 个人帐号登录
            if (model.mobileLogin) {
                // 区分手机号登录
                passwd = $scope.mobilePasswordInput.value;
                if(isValUnvalid($scope.mobileInput.value)) {
                    me.showErrorTip("phoneBlank", $scope);
                    refreshVerifyCode(model);
        
                    me.restoreBtn($scope);
                    return;
                }
                if(isValUnvalid(passwd)) {
                    me.showErrorTip("pwdBlank", $scope);
                    refreshVerifyCode(model);

                    me.restoreBtn($scope);
                    return;
                }
            } else {
                // 非手机号登录 判断非空
                passwd = $scope.personalPasswordInput.value;
                // 修复自动填充帐号密码时 触发到了个人帐号输入框personalAccountInput的change事件 导致存储密码的变量值被清空的bug
                if ($("#"+$scope.personalPasswordInput.id+">input").val() !== "") {
                    passwd = $("#"+$scope.personalPasswordInput.id+">input").val();
                }
                // 修复自动填充时帐号名为空的错误场景
                if ($("#"+$scope.personalAccountInput.id+">input").val() !== "") {
                    $scope.personalAccountInput.value = $("#"+$scope.personalAccountInput.id+">input").val();
                }
                if (isValUnvalid($scope.personalAccountInput.value)) {
                    me.showErrorTip("accountNameBlank", $scope);
                    refreshVerifyCode(model);

                    me.restoreBtn($scope);
                    return;
                }
                if(isValUnvalid(passwd)) {
                    me.showErrorTip("pwdBlank", $scope);
                    refreshVerifyCode(model);

                    me.restoreBtn($scope);
                    return;
                }
            }
        } else {
            // IAM子用户方式登录
            passwd = $scope.IAMPasswordInput.value;
            if($scope.IAMAccountInput.value === "op_service") {
                me.showErrorTip("domainWrong", $scope);
                $scope.IAMAccountInput.value = "";
                $scope.IAMUsernameInput.value = "";
                model.pwd = "";
                model.checkCode ="";
                refreshVerifyCode(model);

                me.restoreBtn($scope);
                return;
            }
            if(isValUnvalid($scope.IAMAccountInput.value)) {
                me.showErrorTip("accountNameBlank", $scope);
                refreshVerifyCode(model);

                me.restoreBtn($scope);
                return;
            }

            if(isValUnvalid($scope.IAMUsernameInput.value)) {
                me.showErrorTip("userNameBlank", $scope);
                refreshVerifyCode(model);
    
                me.restoreBtn($scope);
                return;
            }

            if(isValUnvalid(passwd)) {
                me.showErrorTip("pwdBlank", $scope);
                refreshVerifyCode(model);

                me.restoreBtn($scope);
                return;
            }
        }

        if($("#verifyCode").is(":visible") && isValUnvalid(checkCode))
        {
            model.checkCodeErrorMsg = i18n('checkCodeBlank');
            me.showErrorTip("checkCodeBlank", $scope);
            refreshVerifyCode(model);

            me.restoreBtn($scope);
            return;
        }

        //非空校验完后校验输入参数是否合法
        if($("#verifyCode").is(":visible") && !checkCodeLength(checkCode)){
            model.checkCodeErrorMsg = i18n('validCheckCode');
            me.showErrorTip("checkCodeBlank", $scope);

            model.checkCode = "";
            refreshVerifyCode(model);

            me.restoreBtn($scope);
            return;
        }

        if(!checkUserOrEmailOrPhone(userName)){
            me.showErrorTip("domainWrong", $scope);

            model.userName = "";
            model.pwd = "";
            model.checkCode = "";
            refreshVerifyCode(model);

            me.restoreBtn($scope);
            return;
        }

        if(!checkPwd(passwd))
        {
            me.showErrorTip("domainWrong", $scope);
            model.pwd = "";
            model.checkCode = "";
            refreshVerifyCode(model);

            me.restoreBtn($scope);
            return;
        }
        // clearSensitiveInfo();

        // 增加对输入手机号登录的兼容
        var phonePatternRegex = /^1\d{10}$/;
        if (phonePatternRegex.test($scope.personalAccountInput.value) && !model.isCompany && !model.mobileLogin && !$scope.ipIsInternational) {
            // 如果输入是手机号格式 且 非子用户登录
            iamHttpService.post({
                url: "/authui/findowner",
                params: {
                    type: "mobile",
                    value: $scope.personalAccountInput.value
                }
            }).then(function (data) {
                var data = typeof data === 'object' ? data : $.parseJSON(data);
                if (data.result === "success") {
                    var count = data.count;
                    if (count > 0) {
                        // 已经注册 区分单个帐号多个帐号的显示逻辑
                        if (count > 1) {
                            // 多帐号时 切换到手机登录
                            $scope.mobileInput.value = $scope.personalAccountInput.value;
                            $scope.personalAccountInput.value = "";
                            $scope.mobileLoginModel.isMobilePattern = false;
                            $scope.model.mobileLogin = true;
                            $scope.mobileLoginModel.switchTypeLabel = i18n("mobileLoginModel.accountLogin");
                            $scope.mobileLoginModel.showMobileSelect = true;

                            // 处理数据格式用以适配控件
                            for (var i = 0; i < data.users.length; i++) {
                                data.users[i].selectId = i + 1;
                                data.users[i].label = data.users[i].name;
                                if (i==0) {
                                    $scope.mobileLoginModel.loginUserId = data.users[i].id;
                                    $scope.mobileLoginModel.loginUserDomainId = data.users[i].domain_id;
                                }
                            }
                            $scope.model.pwd = "";
                            
                            $scope.mobileUsers.selectOptions = data.users;
                            $scope.$apply();
                            // 重新渲染之后得到控件 设置默认值
                            $("#mobileUsers").widget().opChecked("1");
                            // 再启用登录按钮
                            me.restoreBtn($scope);
                        } else {
                            // 单帐号
                            getRiskMonitor();
                        }
                    } else {
                        getRiskMonitor();
                    }
                } else {
                    // 请求返回错误
                    if (data.message === "addrFrequencyHitMax") {
                        $scope.model.serverError = iamUtils.i18nFormat(i18n("mobileLoginModel.operationTooFrequent"), 5);
                        $scope.model.pwd = "";
                        $("#checkError").hide();
                        $("#serverError").show();
                        $scope.$apply();
                        // 再启用登录按钮
                        me.restoreBtn($scope);
                    }
                }
            }, function() {
                showErrorMsg($scope, "417");
                window.hwcap.reload();
                // 再启用登录按钮
                me.restoreBtn($scope);
            });
        } else {
            getRiskMonitor();
        }

        function getRiskMonitor() {
            var hwmeta = document.getElementById("hwmeta") ? document.getElementById("hwmeta").value : "";

            var params = {
                _domain: "",
                _domainType: "",
                _username: "",
                _countryCode: countryCode,
                _verifycode: checkCode,
                _password: encodeURIComponent( passwd ),
                _companyLogin: isCmpyLogin,
                _userInfoType: "",
            };

            if (model.isCompany) {
                // 子用户方式登录
                params._domainType = "name";
                params._username = encodeURIComponent($scope.IAMUsernameInput.value);
                params._domain = encodeURIComponent($scope.IAMAccountInput.value);
                params._userInfoType = me.getUserNameType($scope.IAMUsernameInput.value);
            } else {
                if (model.mobileLogin) {
                    // 当手机号登录
                    params._domain = $scope.mobileLoginModel.loginUserDomainId;
                    params._domainType = "id";
                    params._username = $scope.mobileLoginModel.loginUserId;
                    params._userInfoType = "id"; 
                } else if(me.getUserNameType($scope.personalAccountInput.value) === "email" && $scope.emailUsers.selectOptions.length > 0){
                    // 主帐号邮箱方式登录
                    params._domain = $scope.emailLoginModel.loginUserDomainId;
                    params._domainType = "id";
                    params._username = $scope.emailLoginModel.loginUserId;
                    params._userInfoType = "id"; 
                } else {
                    // 主帐号方式登录
                    params._domainType = "name";
                    params._username = encodeURIComponent($scope.personalAccountInput.value);
                    params._domain = "";
                    params._userInfoType = me.getUserNameType($scope.personalAccountInput.value);
                }
            }
            

            var loginPostParams = {
                "userpasswordcredentials.domain": params._domain,
                "userpasswordcredentials.domainType": params._domainType,
                "userpasswordcredentials.username": params._username,
                "userpasswordcredentials.countryCode": params._countryCode,
                "userpasswordcredentials.verifycode": params._verifycode,
                "userpasswordcredentials.password": params._password,
                "userpasswordcredentials.companyLogin": params._companyLogin,
                "userpasswordcredentials.userInfoType": params._userInfoType,
                "userpasswordcredentials.riskMonitorJson":JSON.stringify({
                    "devID": get_Cookie("cbc-sid"),
                    "hwMeta": hwmeta ? hwmeta : ""
                }),
                __checkbox_warnCheck: "true",
                "isAjax":"true",
                Submit: "Login"
            }

            doLogin('/authui/validateUser.action'+ filterSearch(), loginPostParams);
            return ;
        }

        function timetrans(){
            var date = new Date();
            var Y = date.getFullYear();
            var M = (date.getMonth()+1 < 10 ? '0'+(date.getMonth()+1) : date.getMonth()+1);
            var D = (date.getDate() < 10 ? '0' + (date.getDate()) : date.getDate());
            var h = (date.getHours() < 10 ? '0' + date.getHours() : date.getHours());
            var m = (date.getMinutes() <10 ? '0' + date.getMinutes() : date.getMinutes());
            var s = (date.getSeconds() <10 ? '0' + date.getSeconds() : date.getSeconds());
            return ''+Y+M+D+h+m+s;
        }

        function doLogin(URL, PARAMS) {
            iamHttpService.post({
                url: URL,
                params: PARAMS
            }).then(function (data) {
                if (data.loginResult === "success") {

                    // 登录成功后记录cookie
                    recordLoginCookie($scope, countryCode, "forLogin");

                    var redirectUrl;
                    var redirectUrlArr = data.redirectUrl.split("?");
                    if (/\/authui\/.*.html/.test(redirectUrlArr[0])) {
                        var hash = redirectUrlArr[0].replace("/authui/", "").replace(".html", "");
                        if (redirectUrlArr.length > 1) {
                            redirectUrl = "?" + redirectUrlArr[1] + "#/" + hash;
                        } else {
                            redirectUrl = "#/" + hash;
                        }
                    } else {
                        redirectUrl = data.redirectUrl;
                    }
                    window.location.href = redirectUrl;
                } else if (data.loginResult === "failed"){

                    // 登录失败时 记录当前的帐号cookie 方便用户点击忘记密码时 回填在页面
                    recordLoginCookie($scope, countryCode, "forFindPwd");

                    if (data.authFailed === true) {
                        if($scope.model.mobileLogin === false){
                            me.loginVerify($scope);
                        }else{
                            me.loginVerify($scope);
                        }
                    }
                    showErrorMsg($scope, data.errorCode);
                    window.hwcap.reload();
                    me.restoreBtn($scope);
                }else {
                    showErrorMsg($scope, "417");
                    window.hwcap.reload();
                    me.restoreBtn($scope);
                }
            }, function(){
                showErrorMsg($scope, "417");
                window.hwcap.reload();
                me.restoreBtn($scope);
            });
        }

        function filterSearch() {
            var newSearch = "";
            var searchStr = window.location.search.substring(1);
            var params = searchStr.split("&");
            for (var index = 0; index < params.length; index++) {
                if (params[index].indexOf("=") !== -1){
                    var key = params[index].substring(0, params[index].indexOf("="));
                    if (key === "service") {
                        var service = params[index];
                        if (service.indexOf("hwclouds") !== -1){
                            service = service.replace(/hwclouds/g, "huaweicloud");
                        }
                        newSearch = newSearch + "&" + service
                    }else if((key !== "step")){
                        newSearch = newSearch + "&" + params[index];
                    }
                }
            }
            return newSearch === "" ? "" : "?" + newSearch.substring(1);
        }

        function clearSensitiveInfo() {
            $scope.personalPasswordInput.value = new Array($scope.personalPasswordInput.value.length + 1).join("*");
            $scope.mobilePasswordInput.value = new Array($scope.mobilePasswordInput.value.length + 1).join("*");
            $scope.IAMPasswordInput.value = new Array($scope.IAMPasswordInput.value.length + 1).join("*");
        }

        function checkAccount(value){
            var maxLength = securityPolicy.accountpolicy.username_maxlen;
            if(value.length > maxLength){
                return false;
            }
            var userPattern = new RegExp(securityPolicy.accountpolicy.username_contains_char);
            return userPattern.test(value);
        }

        function checkUserOrEmailOrPhone(value){
            var maxLength = 255;//取邮箱、手机、用户名的最大值：邮箱255
            if(value.length > maxLength){
                return false;
            }

            //var userPattern = new RegExp(securityPolicy.accountpolicy.username_contains_char);
            var emailPattern = iamUtils.EmailRegex;
            var phonePattern = /^[0-9]\d*$/;

            if(phonePattern.test(value))
            {
                return true;
            }
            if(emailPattern.test(value))
            {
                return true;
            }
            if(value.indexOf("@") != -1)
            {
                return false;
            }
            else
            {
                return true;
            }

            //return userPattern.test(value) || emailPattern.test(value) || phonePattern.test(value);
        }

        function checkPwd(value){
            var maxLength = securityPolicy.passwordpolicy.password_maxlen;
            if(value.length > maxLength){
                return false;
            }
            return true;
        }

        function checkCodeLength(vaule){
            var maxLength = 4;//图片验证码长度为4
            if(vaule.length > maxLength){
                return false;
            }
            return true;
        }

        function showServerError() {
            var msgParentDom = $("#checkError");
            msgParentDom.hide();
            var serverError = $("#serverError");
            serverError.show();
        }
    }

    LoginController.prototype.onUserTypeChange = function($scope, $timeout) {
        $timeout(function () {
            // 如果url中未带有id参数则说明没有使用IAM用户登录链接 该场景下才需清空输入框
            if (iamUtils.getUrlParams()["id"] === undefined) {
                $scope.IAMAccountInput.value = "";    
            }
            $scope.IAMUsernameInput.value = "";
            $scope.IAMPasswordInput.value = "";
            $scope.IAMPasswordInput.pwdVisible = false;
            $scope.personalAccountInput.value = "";
            $scope.personalAccountInput.oldValue = "";
            $scope.personalPasswordInput.value = "";
            $scope.personalPasswordInput.pwdVisible = false;
            $scope.emailLoginModel.showEmailSelect = false;

            $scope.model.accountName = "";
            $scope.model.lastAccountName = "";
            $scope.model.userName = "";
            $scope.model.lastUserName = "";
            $scope.model.PhoneAccountName = "";
            $scope.model.lastPhoneAccountName = "";
            $scope.model.pwd = "";
            $scope.model.checkCode = "";
            $scope.model.rememberChecked = false;
            $scope.model.pwdFocused = false;

            if($scope.model.isCompany) {
                $scope.IAMAccountInput.getFocus();
            } else {
                $scope.personalAccountInput.getFocus();
            }
            if (!$scope.model.userNameCookie) {
                $("#checkError").hide();
                $("#serverError").hide();
                return;
            }

            if (countryCode) {
                $scope.model.defaultValue = iamUtils.getCountryValue($scope.model.codeJson, countryCode);
            }

            var lastLoginType = cookieOp.getCookie("loginType");
            var countryCode = cookieOp.getCookie("countryCode");
            // 是否记住登录名
            var rememberChecked = cookieOp.getCookie("rememberChecked");
            
            me.loginCheck($scope);
            
            $("#checkError").hide();
            $("#serverError").hide();
        });
    }

    function refreshVerifyCode(model){
        if(model.isNeedVerifyCode) {
            model.getVerifyCode();
        }
    }

    function showErrorMsg($scope, errorCode) {
        if (me.showStatus !== undefined) {
            me.showStatus(errorCode);
        }
        //将原有的错误信息清空
        $scope.model.serverError = "";
        $scope.model.goLogin = "";
        $scope.model.goLogin1 = "";
        if (errorCode && $scope.model.errorMsgObj[errorCode]) {
            $scope.model.serverError = $scope.model.errorMsgObj[errorCode];
        } else if (errorCode) {
            if(errorCode == i18n("isHongKongUser")) {
                $scope.model.serverError = i18n("isHongKongUser1");
                $scope.model.goLogin = i18n("goLogin.hk");
                $scope.model.goLogin1 = i18n("toLogin.hk");
                $scope.goLoginType="HK";
            } else if (errorCode == i18n("isHwsUser")) {
                $scope.model.serverError = i18n("isHwsUser1");
                $scope.model.goLogin = i18n("goLogin.hws");
                $scope.model.goLogin1 = i18n("toLogin.hws");
                $scope.goLoginType="HWS";
            } else if (errorCode == i18n("isRuUser")) {
                $scope.model.serverError = i18n("isRuUser1");
                $scope.model.goLogin = i18n("goLogin.ru");
                $scope.model.goLogin1 = i18n("toLogin.ru");
                $scope.goLoginType="RU";
            } else if (errorCode == "416") {
                $scope.model.serverError = i18n("clientIpInvalid");
                $scope.model.goLogin = i18n("clientIpInvalid.learnMore");
                $scope.model.goLogin1 = "";
                $scope.goLoginType="ACL";
            } else {
                $scope.model.serverError = errorCode;
            }
        }

        $("#checkError").hide();
        if (errorCode !== "") {
            $("#serverError").show();
        }
        // 清除密码输入框
        resetPwdInput($scope);

        refreshVerifyCode($scope.model);
        $scope.$evalAsync();
    }

    // 清除密码输入框
    function resetPwdInput($scope) {
        if ($scope.personalPasswordInput) {
            $scope.personalPasswordInput.value = "";
        }
        if ($scope.mobilePasswordInput) {
            $scope.mobilePasswordInput.value = "";
        }
        if ($scope.IAMPasswordInput) {
            $scope.IAMPasswordInput.value = "";
        }
    }

    function get_Cookie(e){
        var n, t = "", r = document["getElementById"]("JSdev");
        if (r && !t)
            try {
                n = r.getsid() || "",
                    t = n
            } catch (o) {}
        try {
            window["localStorage"] && !t && (n = localStorage[e] || "",
                t = n)
        } catch (o) {}
        if (window["navigator"]["cookieEnabled"] && !t) {
            var i = document["cookie"]["indexOf"](e + "=");
            if (-1 != i) {
                i += e.length + 1;
                var a = document["cookie"]["indexOf"](";", i);
                -1 == a && (a = document["cookie"]["length"]),
                    n = decodeURIComponent(document["cookie"]["substring"](i, a)) || "",
                    t = n
            }
        }

        return t;
    }

    function initUserType($scope) {
        var enterpriseUser = i18n("enterpriseUser");
        var personageUser = i18n("personageUser");
        $scope.model.currentUserType = $scope.model.isCompany ? enterpriseUser : personageUser;
        $scope.model.otherUserType = $scope.model.isCompany ? personageUser : enterpriseUser;
        
		var idUrl = iamUtils.getUrlParams()["id"];

        // 根据url中是否带有id参数区分是否使用了 IAM用户登录链接
        if (idUrl === undefined) {
            // 上次登录的情形会被cookie记录 默认区分 个人帐号和IAM用户登录方式
            if (me.getLastLoginUserType() === "company") {
                if (cookieOp.getCookie("rememberChecked") || cookieOp.getCookie("findPwdEnd")) {
                    $scope.IAMAccountInput.value = cookieOp.getCookie("IAMAccount");
                    $scope.IAMUsernameInput.value = cookieOp.getCookie("IAMUsername");
                    $scope.IAMPasswordInput.value = "";
                    $scope.IAMPasswordInput.getFocus();
                } else {
                    $scope.IAMAccountInput.getFocus();
                }
            } else if (me.getLastLoginUserType() === "mobile" && !$scope.ipIsInternational) {
                $scope.model.mobileLogin = true;
                $scope.mobileLoginModel.switchTypeLabel = i18n("mobileLoginModel.accountLogin");
                if (cookieOp.getCookie("rememberChecked") || cookieOp.getCookie("findPwdEnd")) {
                    $scope.mobileInput.value = cookieOp.getCookie("mobile");
                    $scope.mobileBlur();
                    $scope.mobilePasswordInput.value = "";
                    $scope.mobilePasswordInput.getFocus();
                } else {
                    $scope.mobileInput.focused = true;
                }
            } else if (me.getLastLoginUserType() === "personal") {
                if (cookieOp.getCookie("rememberChecked") || cookieOp.getCookie("findPwdEnd")) {
                    $scope.personalAccountInput.value = cookieOp.getCookie("personalAccount");
                    $scope.personalPasswordInput.value = "";
                    $scope.personalPasswordInput.getFocus();
                } else {
                    $scope.personalAccountInput.getFocus();
                }
            } else if (me.getLastLoginUserType() === "idp") {
                $scope.model.isIdpLogin = true;
                if (cookieOp.getCookie("rememberChecked") || cookieOp.getCookie("enterprise_idp")) {
                    try {
                        var cookieObj = JSON.parse(cookieOp.getCookie("enterprise_idp"));
                        if (cookieObj) {
                            $scope.idpAccountInput.value = cookieObj.domainName;
                            $scope.getIDPs($scope, cookieObj.selectedIdpId);
                        }
                    } catch (err) { }
                }
            } else {
                $scope.personalAccountInput.getFocus();
                // 如果未保存上次登录的cookie 则国内IP默认设置为手机号登录方式
                if (!$scope.ipIsInternational) {
                    /* 暂时不使用默认手机号登录方式
                    // setMobileLogin();
                    $scope.model.isCompany = false;
                    $scope.model.mobileLogin = true;
                    // $scope.model.lastUserName = "";
                    $scope.model.areaCodeDisabled = true;
                    $scope.mobileLoginModel.switchTypeLabel = i18n("mobileLoginModel.accountLogin");

                    $scope.mobileInput.oldValue = "";
                    $scope.mobileInput.value = "";
                    $scope.mobileInput.getFocus();
                    $scope.mobilePasswordInput.value = "";
                    */
                }
            }
        } else {
            $scope.model.isCompany = true;
            $scope.IAMAccountInput.value = encodeURIComponent(idUrl);
            $scope.IAMAccountInput.disable = true
            $scope.IAMUsernameInput.value = "";
            $scope.IAMUsernameInput.getFocus();
            $scope.IAMPasswordInput.value = "";
            // 不记住登录名
            $scope.model.rememberChecked = false;
        }

        if(!$scope.$$phase) { 
            $scope.$apply(); 
        } 
        return;
    }

    LoginController.prototype.loginCheck = function($scope) {
        if ($scope.model.isCompany && (!$scope.IAMAccountInput.value || !$scope.IAMUsernameInput.value)) {
            $scope.model.isNeedVerifyCode = false;
            return;
        }
        if (!$scope.model.isCompany && !$scope.personalAccountInput.value) {
            $scope.model.isNeedVerifyCode = false;
            return;
        }
        if ($scope.model.mobileLogin && !$scope.mobileInput.value) {
            $scope.model.isNeedVerifyCode = false;
            return;
        }
        me.loginVerify($scope);
    }

    // 检查登录使用的帐号是否需要填写图形验证码
    LoginController.prototype.loginVerify = function($scope) {
        var params;
        if (!$scope.model.isCompany) {
            // 个人帐号登录方式
            if ($scope.model.mobileLogin) {
                // 手机号登录方式
                params = {
                    userName: $scope.mobileLoginModel.loginUserId,
                    userType: "id",
                    accountName: $scope.mobileLoginModel.loginUserDomainId
                }
            } else {
                // 帐号邮箱登录方式 需要兼容填写了手机号的登录
                var personalAccount = $scope.personalAccountInput.value.trim();
                var type = me.getUserNameType(personalAccount);
                if (type === "email"){
                    // 邮箱登录
                    params = {
                        userName: $scope.emailLoginModel.loginUserId,
                        userType: "id",
                        accountName: $scope.emailLoginModel.loginUserDomainId
                    }
                }else {
                    if (type === "mobile") {
                        var countryCode = $("#codeSelectId").length > 0 ?  iamUtils.getCodeValue($scope.model.codeJson, $("#codeSelectId").widget().getValue()): iamUtils.getCodeValue($scope.model.codeJson, $scope.model.defaultValue);
                        personalAccount = countryCode + "-" + personalAccount;
                    }
                    params = {
                        userName: personalAccount,
                        userType: type,
                        accountName: ""
                    }
                }
            }
        } else {
            // IAM子用户登录方式
            var IAMUsername = $scope.IAMUsernameInput.value.trim();
            var type = me.getUserNameType(IAMUsername);
            if (type === "mobile") {
                var countryCode = $("#codeSelectId").length > 0 ?  iamUtils.getCodeValue($scope.model.codeJson, $("#codeSelectId").widget().getValue()): iamUtils.getCodeValue($scope.model.codeJson, $scope.model.defaultValue);
                IAMUsername = countryCode + "-" + IAMUsername;
            }
            params = {
                userName: IAMUsername,
                userType: type,
                accountName: $scope.IAMAccountInput.value ? encodeURIComponent($scope.IAMAccountInput.value) : ""
            }
        }
        
        iamHttpService.post({
            url: "/authui/login/verify",
            params: params
        }).then(function (data) {
            if($scope.model.mobileLogin === true && $scope.mobileInput.value === undefined){
                $scope.model.isNeedVerifyCode = false;
            }else{
                $scope.model.isNeedVerifyCode = data.needVerify;
            }
            $scope.$apply();
        }, function() {
            $scope.model.isNeedVerifyCode = true;
            $scope.$apply();
        });
    }
    LoginController.prototype.getUserNameType = function(userName){
        var emailPattern = iamUtils.EmailRegex;
        var phonePattern = /^[0-9]\d*$/;
        if(emailPattern.test(userName)) {
            return "email";
        } else if (phonePattern.test(userName)) {
            return "mobile";
        } else {
            return "name";
        }
    };

    LoginController.prototype.getPageImgSrc = function(){
        if(window.language === "zh-cn")
        {
            return require("custom/images/loginimg_zh-cn.png");
        }
        else
        {
            return require("custom/images/loginimg_en-us.png");
        }
    }

    return LoginController;
});



// WEBPACK FOOTER //
// ./public/hws/js/login2/controllers/baseLoginController.js